export interface ReplaceConsentTextProps {
  text: string;
  siteName: string;
}

export function replaceConsentText({
  text,
  siteName = "",
}: ReplaceConsentTextProps) {
  return text.replaceAll("$EVENT_NAME", siteName);
}
